import { CLEAR_MODAL_PROFILE, SET_MODAL_PROFILE } from 'store/types/profile';

const initialState = {
  modal: {
    isOpen: false,
  },
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MODAL_PROFILE:
      return {
        ...state,
        modal: {
          ...state.modal,
          ...action?.payload,
        },
      };
    case CLEAR_MODAL_PROFILE:
      return {
        ...state,
        modal: initialState.modal,
      };
    default:
      return state;
  }
};

export default profileReducer;
